/* eslint-disable no-shadow */
import { call, takeEvery } from "redux-saga/effects";
import noop from "lodash.noop";

import {
    CURRENT_INSTANCE_REQUESTED,
    defaultScopeId,
    failCurrentInstance,
    succeedCurrentInstance,
} from "./instance.duck";

import { loadCurrentInstance } from "./instance.api";

import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";

import {
    getId,
    injectApiWithContextFactory,
    injectBoundActionCreatorsFactory,
} from "Utils/sagaUtils";

export const withBoundActions = injectBoundActionCreatorsFactory(
    {
        succeedCurrentInstance,
        failCurrentInstance,
    },
    getId,
    defaultScopeId
);

export const withApiContext = injectApiWithContextFactory(
    {
        loadCurrentInstance,
    },
    injectBoundGQLClient
);

export function* loadCurrentInstanceSaga({
    actions: { succeedCurrentInstance, failCurrentInstance },
    api: { loadCurrentInstance },
    resolve = noop,
    reject = noop,
}) {
    try {
        const result = yield loadCurrentInstance();
        yield succeedCurrentInstance(result);
        yield call(resolve);
    } catch (e) {
        yield failCurrentInstance(e);
        yield call(reject, e);
    }
}

export default () =>
    function* rootSaga() {
        yield takeEvery(
            CURRENT_INSTANCE_REQUESTED,
            withBoundActions(withApiContext(loadCurrentInstanceSaga))
        );
    };
